// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"56":"offer_page","95":"faq_page","473":"main_page","923":"old_main_page"}[chunkId] || chunkId) + "." + {"56":"80326926","95":"175c3112","147":"c5bd1145","473":"4c0cec1c","580":"fd09df0a","921":"b53d047d","923":"6f5b074a"}[chunkId] + ".chunk.js";
};